import Button from "components/Button/Button";
import Icon from "components/Icon/Icon";
import styled from "styled-components";
import { Currency } from "styles/parcelsStyles";

export const Wrapper = styled.ul`
  width: 100%;
  margin: 10px 0 0 0;
  padding: 0;
`;

export const PriceWrapper = styled.div`
  display: flex;
  align-items: center;

  span {
    margin-right: 4px;
  }

  i {
    margin-left: 4px;
  }
`;

export const TooltipInfo = styled.div`
  max-width: 220px;
  width: 100%;
  line-height: 1.4;
  white-space: normal;
`;

export const DashConnector = styled.div`
  width: 100%;
  margin: 3px 8px;
  border-bottom: 1px dashed ${(props) => props.theme.divider};
`;

export const PriceItem = styled.li`
  display: flex;
  justify-content: space-between;
  list-style: none;
  white-space: nowrap;
  margin-bottom: 15px;

  &:last-child {
    font-size: 16px;
    margin-top: 18px;

    div {
      font-weight: 700;
    }
  }
`;

export const TotalPriceItem = styled(PriceItem)`
  padding-top: 10px;
`;

export const InsuranceCheckBoxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const InsuranceHelpIcon = styled(Icon)`
  margin-left: 8px;
  width: 20px;
  height: 20px;
  background-color: ${({ theme }) => theme.overlayMedium};
`;

export const InsuranceConfirmation = styled.div`
  display: flex;
  width: 50%;
  justify-content: flex-end;
  padding-left: 8px;
  padding-right: 8px;
`;

// Compact: the pair sits inside a price row.
export const InsuranceButton = styled(Button)`
  padding: 0 10px;
`;

export const InsurancePriceWrapper = styled(PriceWrapper)`
  color: ${(props) => props.theme.primaryLight};

  span {
    color: ${(props) => props.theme.primaryLight} !important;
  }
`;

export const Separator = styled.div`
  background-color: ${(props) => props.theme.divider};
  height: 1px;
  margin-top: 20px;
  margin-bottom: 10px;
`;

export const SummaryPriceItem = styled(PriceItem)`
  justify-content: flex-end;
`;

export const SummaryLabel = styled.div`
  display: flex;
  align-items: center;
`;

export const SummaryHelpIcon = styled(Icon)`
  margin-left: 8px;
  width: 20px;
  height: 20px;
  background-color: ${({ theme }) => theme.overlayMedium};
`;

export const SummaryTooltipContent = styled.div`
  max-width: 220px;
  line-height: 1.4;
  white-space: normal;
`;

interface SummaryPriceWrapperProps {
  $tone?: "default" | "positive" | "negative";
}

const getSummaryPriceToneColor = (
  tone: SummaryPriceWrapperProps["$tone"],
  theme: any,
) => {
  if (tone === "positive") {
    return theme.green;
  }

  if (tone === "negative") {
    return theme.red;
  }

  return "inherit";
};

export const SummaryPriceWrapper = styled(PriceWrapper)<SummaryPriceWrapperProps>`
  min-width: 50px;
  margin-left: 8px;
  justify-content: flex-end;

  color: ${({ $tone, theme }) => getSummaryPriceToneColor($tone, theme)};

  span {
    color: ${({ $tone, theme }) => getSummaryPriceToneColor($tone, theme)};
  }
`;

export const SummaryCurrency = styled(Currency)`
  margin-right: 0 !important;
`;
